import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { CalenderBaseComponent } from 'src/app/components/base/calendar.component';
import { PostService } from 'src/app/services/repositories/post.service';
import { TranslationService } from 'src/app/services/utilities/translation.service';
import { UiStateService } from 'src/app/services/utilities/ui-state.service';
import { CalendarService } from 'src/app/services/utilities/calendar.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-post-label-preview',
  templateUrl: './post-label-preview.component.html',
  styleUrls: ['./post-label-preview.component.scss'],
})
export class PostLabelPreviewComponent extends CalenderBaseComponent {
  @Input() post: any;
  @Input() screenWidth: number = 0;
  @Input() screenHeight: number = 0;
  @Input() postHour: string = '';
  @Input() homePage: boolean = false;
  @Output() labelClicked = new EventEmitter();
  previewIndex: number = 0;
  apiUrl = environment.apiUrl;
  mediaPreview: string = '';
  posted: Boolean = false; 
  planned: Boolean = false;   
  failed:Boolean =false;
  @Output() hidedPost = new EventEmitter<any>();
  @Output() showedPost = new EventEmitter<any>();
  displayedGroups: any[] = [];
  hiddenGroupCount: number = 0;
  isGroupNamesToolTip: boolean = false;


  constructor(
    protected override uiStateService: UiStateService,
    protected override postService: PostService,
    protected override translationService: TranslationService,
    protected override calendarService: CalendarService,
    private el: ElementRef,
    private cdr: ChangeDetectorRef
  ) {
    super(translationService, calendarService, postService, uiStateService);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this. preparePost();
  }

  preparePost(){
    this.getPostHour();
    this.choiceMediaPreview();
    this.postType();
  }

  numberOfEmptyArray(nb: number): any[] {
    return new Array(nb);
  }

  getPostHour(){
    const date = new Date(this.post.publishingDatetime ? this.post.publishingDatetime : this.post.expectedPublishingDatetime);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    this.postHour = `${hours}:${minutes}`;
  }

  choiceMediaPreview(){
    if(this.post.googleMedias.length > 0){
      this.mediaPreview = this.post.googleMedias[0].url;
      return
    }
    
    if(this.post.linkedinMedias.length > 0){
      this.mediaPreview = this.post.linkedinMedias[0].url;
      return
    }
    
    if(this.post.facebookMedias.length > 0){
      this.mediaPreview = this.post.facebookMedias[0].url;
      return
    }
    
    if(this.post.instagramMedias.length > 0){
      this.mediaPreview = this.post.instagramMedias[0].url;
      return
    }
  }

  postType(){
    const hasFailed= this.post.SocialPlatforms.some((a:any)=> 'externalId' in a && a.externalId==null && this.post.publishingDatetime!=null );
    if(new Date(this.post.expectedPublishingDatetime) > new Date() && !this.post.publishingDatetime){
      this.planned = true;
    }
    if(new Date(this.post.expectedPublishingDatetime) < new Date() && !this.post.publishingDatetime || hasFailed){
      this.failed = true ;
    }
    else {
      this.posted = true && !hasFailed;
    }
  }

  mediaIsVideo(media: any): boolean {
    return media?.mimeType?.startsWith('video') ?? false;
  }

  postDetails() {
    if(this.posted){
      const postId = this.post.id
      let mediaQuery = `/library/post-details/${postId}`;

      if(this.post.publishingDatetime==null && this.post.expectedPublishingDatetime!=null && new Date(this.post.expectedPublishingDatetime) > new Date()){
        mediaQuery =  '/calendar/day/'+this.post.expectedPublishingDatetime+'/'+ this.post.id
      }

      window.location.href = mediaQuery;
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.calculateDisplayedGroups();
      this.cdr.detectChanges();
    }, 100);
  }

  calculateDisplayedGroups() {
    if (!this.post?.groups || this.post.groups.length === 0) {
      this.displayedGroups = [];
      this.hiddenGroupCount = 0;
      console.log('No groups to display');
      return;
    }

    const container = this.el.nativeElement.querySelector('.inline-container');
    if (!container) {
      console.warn('Inline container not found, displaying all groups');
      this.displayedGroups = this.post.groups;
      this.hiddenGroupCount = 0;
      return;
    }

    const maxWidth = container.offsetWidth || 200;

    const tempContainer = document.createElement('span');
    tempContainer.style.visibility = 'hidden';
    tempContainer.style.position = 'absolute';
    tempContainer.style.whiteSpace = 'nowrap';
    tempContainer.style.fontSize = getComputedStyle(container).fontSize;
    tempContainer.style.fontFamily = getComputedStyle(container).fontFamily;
    tempContainer.style.fontWeight = getComputedStyle(container).fontWeight;
    tempContainer.style.letterSpacing = getComputedStyle(container).letterSpacing;
    tempContainer.style.lineHeight = getComputedStyle(container).lineHeight;
    document.body.appendChild(tempContainer);

    this.displayedGroups = [];
    this.hiddenGroupCount = 0;

    // Measure ellipsis width
    tempContainer.textContent = `... +${this.post.groups.length}`;
    const ellipsisWidth = tempContainer.offsetWidth || 20;

    let currentText = '';
    for (let i = 0; i < this.post.groups.length; i++) {
      const group = this.post.groups[i];
      const separator = i < this.post.groups.length - 1 ? ', ' : '';
      currentText += (currentText ? ', ' : '') + group.name;

      // Test with ellipsis if there are more groups
      tempContainer.textContent = currentText + (i < this.post.groups.length - 1 ? `, ... +${this.post.groups.length - i - 1}` : '');
      const currentWidth = tempContainer.offsetWidth;


      if (currentWidth <= maxWidth) {
        this.displayedGroups.push(group);
      } else {
        this.hiddenGroupCount = this.post.groups.length - this.displayedGroups.length;
        break;
      }
    }

    // Fallback: Show at least one group if none fit
    if (this.displayedGroups.length === 0 && this.post.groups.length > 0) {
      // console.warn('No groups fit, showing first group');
      this.displayedGroups = [this.post.groups[0]];
      this.hiddenGroupCount = this.post.groups.length - 1;
    }

    document.body.removeChild(tempContainer);
  }

}
